import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CnetDecimalPipe } from './decimal.pipe';


@NgModule({
  declarations: [
    CnetDecimalPipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    CnetDecimalPipe
  ],
})
export class DecimalPipeModule { }
